import { useState, useEffect, useRef } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { formatPrice } from "@/utils/currency";
import { LoadingScreen } from "@/components/layout/LoadingScreen";

export function CancelacionesTab() {
  const { authAxios } = useAuth();
  const authAxiosRef = useRef(authAxios);
  authAxiosRef.current = authAxios;
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    authAxiosRef.current.get("/tables/cancellations/history").then(res => { setHistory(res.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  if (loading) return <LoadingScreen />;
  return (
    <div data-testid="cancelaciones-tab">
      <p className="text-sm text-muted-foreground mb-4">Historial de mesas canceladas. Los registros nunca se eliminan.</p>
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead><tr className="border-b border-gray-100 text-gray-500 text-xs uppercase">
            <th className="text-left p-3 font-medium">Mesa</th>
            <th className="text-left p-3 font-medium">Fecha</th>
            <th className="text-left p-3 font-medium">Cancelado por</th>
            <th className="text-center p-3 font-medium">Pedidos</th>
            <th className="text-right p-3 font-medium">Total</th>
            <th className="text-center p-3 font-medium">Items</th>
          </tr></thead>
          <tbody className="divide-y divide-gray-50">
            {history.map(c => (
              <tr key={c.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => setExpanded(expanded === c.id ? null : c.id)} data-testid={`cancel-row-${c.id.slice(0,8)}`}>
                <td className="p-3 font-bold">{c.table_name || `MESA ${String(c.table_number).padStart(2,"0")}`}</td>
                <td className="p-3 text-gray-600">{c.cancelled_at ? new Date(c.cancelled_at).toLocaleDateString("es-ES", { day:"2-digit", month:"2-digit", year:"numeric", hour:"2-digit", minute:"2-digit" }) : "-"}</td>
                <td className="p-3">{c.cancelled_by_name || "Desconocido"}</td>
                <td className="p-3 text-center">{c.orders_count || 0}</td>
                <td className="p-3 text-right font-bold text-red-600">{formatPrice(c.total || 0)}</td>
                <td className="p-3 text-center">{c.items?.length || 0}</td>
              </tr>
            ))}
            {history.map(c => expanded === c.id && c.items?.length > 0 && (
              <tr key={`${c.id}-items`} className="bg-gray-50">
                <td colSpan={6} className="p-3">
                  <div className="flex flex-wrap gap-2">
                    {c.items.map((item, i) => (
                      <span key={i} className="bg-white border border-gray-200 rounded-lg px-2.5 py-1 text-xs">
                        {item.qty}x {item.name} <span className="text-gray-400 ml-1">{formatPrice(item.price)}</span>
                      </span>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
            {history.length === 0 && (
              <tr><td colSpan={6} className="p-8 text-center text-gray-400">Sin cancelaciones registradas</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
